// Conteúdos do Salão dos Portais criados para o Baiak (valores propostos; ver IDEIAS.md).
//
// Torre Infinita: andares sem fim, uma leva de monstros por andar (com XP e loot normais). O andar N usa monstros das
// hunts de level ~5×N; depois da hunt mais alta, os monstros ficam mais fortes a cada andar. A cada 10 andares há um boss
// e um ponto de retorno: a próxima entrada começa no último múltiplo de 10 alcançado + 1. Recompensa no primeiro
// clear de cada andar.
// Labirinto do Caos: um labirinto por dia da semana, 15 minutos, monstros da sua faixa de level, 6 baús e o Guardião
// do Caos na saída. 1 entrada por dia (VIP 2).
// Wild Hunts: um descampado com monstros misturados da sua faixa de level (trocam toda semana), +50% de XP e loot,
// monstros +50% mais fortes e o triplo de chance de monstros especiais. Uma instância por faixa de 100 levels. 1 hora por dia.
export const TOWER_CHECKPOINT = 10;
export const TOWER_LEVEL_PER_FLOOR = 5;
export const towerCount = (floor: number) => Math.min(9, 3 + Math.floor(floor / 15));
export const towerGold = (floor: number) => 2_000 * floor;
export const towerStart = (best: number) => Math.floor(best / TOWER_CHECKPOINT) * TOWER_CHECKPOINT + 1;

export const LAB_TIME_MS = 15 * 60_000;
export const LAB_ENTRIES = { free: 1, vip: 2 } as const;
export const labChestGold = (tier: number) => 5_000 * tier;
export const labGuardianGold = (tier: number) => 25_000 * tier;

export const WILD_XP_MULT = 1.5, WILD_LOOT_MULT = 1.5, WILD_POWER = 1.5;
export const WILD_BAND = 100;
export const wildBand = (level: number) => Math.floor(level / WILD_BAND);
export const wildBandName = (b: number) => `${b * WILD_BAND || 1}–${b * WILD_BAND + WILD_BAND - 1}`;
/** semana das Wild Hunts (troca na segunda-feira) */
export const wildWeek = (now = Date.now()) => Math.floor((now / 86400_000 + 3) / 7);
/** Wild Hunts: 1 hora por dia por personagem (decisão do Arthur, 13/10); o tempo conta enquanto você está lá dentro */
export const WILD_DAILY_MS = 60 * 60_000;
